import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import React from "react";

import styles from "./Intro.module.scss";

export const Intro: React.FC = () => {
  return (
    <Grid
      container
      direction="row"
      justifyContent="center"
      alignItems="center"
      spacing={3}
    >
      <Grid item md={7} sm={12}>
        <Typography className={styles.coreHeaderDesc}>
          Empower Your Retail Market Analytics
        </Typography>

        <Box className={styles.coreDesc}>
          A cloud-based retail market intelligence solution that aggregates and
          transforms raw E-commerce data into structured market information with
          machine learning algorithms
        </Box>

        <Box className={styles.requestDemo}>
          <Button
            variant="outlined"
            color="secondary"
            onClick={() => window.open("https://wa.me/85254342376", "_blank")}
          >
            Book a Demo &nbsp; <WhatsAppIcon fontSize="large" />
          </Button>
          <Button
            variant="outlined"
            onClick={() =>
              window.open(
                // eslint-disable-next-line no-secrets/no-secrets
                "https://docs.google.com/forms/d/e/1FAIpQLScsupnw9g1NpdW4ir97txtJU9MSlwEGQ6X_yLrba6hGz0IeNA/viewform",
                "_blank"
              )
            }
          >
            Free Sample Report
          </Button>
        </Box>
      </Grid>
      <Grid item md={5} sm={12}>
        <Box
          component="img"
          sx={{
            width: {
              md: "100%",
              sm: "90%",
              xs: "85%",
            },
          }}
          alt=""
          src="/data-graphic-1.png"
        />
      </Grid>
    </Grid>
  );
};
